

<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="createNew()">Register New Charity</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Merchants.."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #packageTable
               class='material striped datatable'
               [rows]='displayItems'
               [columnMode]='"force"'               
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [messages]='{emptyMessage:"No merchants   to display here!"}'
               [reorderable]="true">

    <ngx-datatable-column prop="status" [sortable]="true" [width]="60" [minWidth]="60" [maxWidth]="60">
        <ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">Status</span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <div class="center">
                <div placement="right" container="body" tooltip="Merchant hasn't accepted the portal invite" *ngIf="!row.active && !row.verified" style="background-color:orangered;" class="circle"></div>
                <div placement="right" container="body" tooltip="Merchant has created their portal login, but hasn't registered with Stripe" *ngIf="!row.active && row.verified" style="background-color:yellow;" class="circle"></div>
                <div placement="right" container="body" tooltip="Merchant onboarding is complete" *ngIf="row.active && row.verified" style="background-color:green;" class="circle"></div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Merchant Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Email
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.email}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="createdBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Created By
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.createdBy}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="modifiedBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Modified By / Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.modifiedBy ? row.modifiedBy : 'empty'}} / {{row.dateModified | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column> 

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Date Created (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.dateCreated | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Last Active (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.lastActive | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column  [sortable]="false" [minWidth]="180" [maxWidth]="180" >
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template prop="actions" let-row="row" ngx-datatable-cell-template >
            <button style="float: right;" class="btn btn-danger btn-icon" (click)="delete(row)"><i class="flaticon-cancel"></i></button>
            <button style="float: right;" class="btn btn-success btn-icon" (click)="edit(row)"><i class="flaticon-edit-1"></i></button>
            <button style="float: right;" [debounceClick] *ngIf="!row.active && !row.verified" class="btn btn-info btn-icon" (click)="resendPortalOnboardingUrl(row)"><i class="flaticon-paper-plane"></i></button>
            <button style="float: right;" *ngIf="row.active && row.verified" class="btn btn-info btn-icon" (click)="openAccountLinkModal(row.merchantId)"><i class="flaticon-map"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>





